/* np-search-recents.js — search recents/trending panel (behavior only;
   ALL styling lives in theme.css so first paint never FOUCs).
   Ported from Ninja Transfers' search upgrade (SEARCH-BAR-HANDOFF-2026-06-10):
   same behavior, NP green styling lives in theme.css, NP trending list. */
(function () {
  if (window.__npSearchRecents) return;
  window.__npSearchRecents = true;

  var LS_KEY = 'np_recent_searches';
  var MAX_RECENTS = 4;
  var TRENDING = ['Embroidered Patches', 'Full Color Patches', 'Rubber PVC Patches', 'Leather Patches'];

  function getRecents() {
    try {
      var raw = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (t) { return typeof t === 'string' && t.trim(); }).slice(0, MAX_RECENTS) : [];
    } catch (e) { return []; }
  }
  function saveTerm(term) {
    term = String(term || '').replace(/\s+/g, ' ').trim();
    if (!term || term.length > 80) return;
    try {
      var list = getRecents().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, MAX_RECENTS)));
    } catch (e) {}
  }

  /* Record terms whenever a search results page is viewed. */
  try {
    if (location.pathname.indexOf('/search') === 0) {
      var q = new URLSearchParams(location.search).get('q');
      if (q) saveTerm(q);
    }
  } catch (e) {}

  /* Icons: fill/stroke as INLINE STYLES on each shape — themes with
     document-scoped svg CSS override presentation attributes (NT got
     solid black discs from fill="none" as an attribute). */
  function clockSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
             '<circle cx="12" cy="12" r="9" style="fill:none;stroke:#3b4754;stroke-width:1.8;"/>' +
             '<path d="M12 7.5V12l3 2" style="fill:none;stroke:#3b4754;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;"/>' +
           '</svg>';
  }
  function trendSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
             '<path d="M3.5 16.5l5.2-5.2 3.6 3.6 7.2-7.4" style="fill:none;stroke:#3b4754;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;"/>' +
             '<path d="M14.5 7.5h5v5" style="fill:none;stroke:#3b4754;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;"/>' +
           '</svg>';
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function rowHTML(icon, term) {
    return '<button type="button" class="np-srch-row" data-term="' + esc(term) + '">' +
             '<span class="np-srch-row__icon">' + icon + '</span>' +
             '<span class="np-srch-row__text">' + esc(term) + '</span>' +
           '</button>';
  }
  function panelHTML() {
    var html = '';
    var recents = getRecents();
    if (recents.length) {
      html += '<div class="np-srch-section"><div class="np-srch-label">Recent Searches</div>';
      for (var i = 0; i < recents.length; i++) html += rowHTML(clockSvg(), recents[i]);
      html += '</div>';
    }
    html += '<div class="np-srch-section' + (recents.length ? ' np-srch-section--divided' : '') + '"><div class="np-srch-label">Trending</div>';
    for (var j = 0; j < TRENDING.length; j++) html += rowHTML(trendSvg(), TRENDING[j]);
    html += '</div>';
    return html;
  }

  function enhance(sf) {
    if (!sf || sf.__npSrchEnhanced) return;
    /* Bind per container — both NP search inputs share the same id
       (#search-form-sidebar appears in the header AND the drawer), so
       never look up by id. */
    var input = sf.querySelector('[data-js-search-input]') || sf.querySelector('input[type="search"], input[name="q"]');
    var form = sf.querySelector('form');
    if (!input || !form) return;
    sf.__npSrchEnhanced = true;
    sf.classList.add('np-srch-enhanced');

    var panel = document.createElement('div');
    panel.className = 'np-srch-panel';
    sf.appendChild(panel);

    function show() {
      if (input.value.trim() !== '') { hide(); return; }
      panel.innerHTML = panelHTML();
      panel.classList.add('is-open');
    }
    function hide() { panel.classList.remove('is-open'); }

    input.addEventListener('focus', show);
    input.addEventListener('click', show);
    input.addEventListener('input', function () {
      if (input.value.trim() === '') show(); else hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      var row = e.target.closest('[data-term]');
      if (!row) return;
      var term = row.getAttribute('data-term') || '';
      saveTerm(term);
      window.location.href = '/search?q=' + encodeURIComponent(term);
    });
    document.addEventListener('click', function (e) {
      if (!sf.contains(e.target)) hide();
    });
    form.addEventListener('submit', function () {
      var v = input.value.trim();
      if (v) saveTerm(v);
    });
  }

  function init() {
    /* The two NP search surfaces: desktop header pill + mobile search drawer. */
    document.querySelectorAll('.headerCustomSearchBar search-form, #site-search-sidebar search-form').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
